import React, { FC } from 'react';

import { Trending } from '@assets/icons';
import { translate } from '@utils/locale';
import { formatAmountInDollars } from '@utils/amount';
import PairPanelCard from '@components/pair-panel-card/PairPanelCard';

import { ValuationUpdateProps } from './types';

// TODO: Add translations , handle negative growth icon

const ValuationUpdateCard: FC<ValuationUpdateProps> = ({ data, growth }) => {
  const renderHeader = () => {
    return (
      <div className="flex items-center mb-[10px]">
        <span className="mr-[6px] text-xl font-semibold">
          {translate('company.valuationTimeline.valuationUpdate')}
        </span>
        {growth && (
          <div className="flex items-center">
            <Trending />
            <span
              className={`text-sm font-normal ${
                growth > 0 ? 'text-green' : 'text-red'
              }`}>
              {`${growth > 0 ? '' : '-'}${formatAmountInDollars(
                Math.abs(growth)
              )}`}
            </span>
          </div>
        )}
      </div>
    );
  };
  return (
    <div>
      <PairPanelCard
        header={renderHeader()}
        panelData={data}
        customStyle="!w-full !max-w-[80%]"
        childrenStyles="!w-[25%]"
      />
    </div>
  );
};

export default ValuationUpdateCard;
